<div class="invoice-modal-backdrop" (click)="onBackdropClick($event)">
  <div class="invoice-modal-panel" role="dialog" aria-modal="true" aria-labelledby="invoice-detail-title">
    <div class="invoice-modal-content">
      <!-- Header with close button -->
      <div class="invoice-modal-header">
        <div class="header-content">
          <div class="invoice-icon">
            <i class="wl_icon_client-download"></i>
          </div>
          <div class="header-info">
            <h2 id="invoice-detail-title">Invoice Details</h2>
            <div class="invoice-subtitle">
              <span>Invoice #{{ invoice?.invoiceNumber || 'N/A' }}</span>
              <span class="badge">{{ invoice?.paymentStatus | titlecase }}</span>
            </div>
          </div>
        </div>
        <button class="close-btn" (click)="onClose()" title="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- Invoice Content -->
      <div class="invoice-content-wrapper">
        <div class="invoice-wrapper">
          <!-- Invoice Header -->
          <div class="invoice-header">
            <div class="invoice-info">
              <div class="invoice-title">INVOICE</div>
              <div class="invoice-number">{{ invoice?.invoiceNumber || 'N/A' }}</div>
              <div class="invoice-date">Invoice date: {{ invoice?.createDate | date:'dd MMM yyyy' }}</div>
            </div>
            <div class="company-info">
              <div class="company-name">{{ invoiceFromAddress?.currentOrganization || 'TechWyse Internet Marketing' }}</div>
              <div>{{ invoiceFromAddress?.street || '1444 Dupont St' }}</div>
              <div>{{ invoiceFromAddress?.city || 'Toronto ON' }} {{ invoiceFromAddress?.code || 'M6P4H3' }}</div>
              <div>{{ invoiceFromAddress?.country || 'Canada' }}</div>
              <!-- <div>Phone: (123) 456-7890</div>
              <div>Email: info&#64;workluge.com</div> -->
            </div>
          </div>

          <!-- Bill To / From Section -->
          <div class="invoice-parties">
            <div class="party-section">
              <div class="party-label">Bill From</div>
              <div class="party-name">{{ invoiceFromAddress?.currentOrganization || 'TechWyse Internet Marketing' }}</div>
              <div class="party-details">
                <div>{{ invoiceFromAddress?.street || '1444 Dupont St' }}</div>
                <div>{{ invoiceFromAddress?.city || 'Toronto ON' }} {{ invoiceFromAddress?.code || 'M6P4H3' }}</div>
                <div>{{ invoiceFromAddress?.country || 'Canada' }}</div>
                <!-- <div>{{ invoice?.fromEmail || '' }}</div>
                <div>{{ invoice?.fromPhone || '' }}</div> -->
              </div>
            </div>
            <div class="party-section">
              <div class="party-label">Bill To</div>
              <div class="party-name">{{ invoice?.currentOrganization || '' }}</div>
              <div class="party-details">
                <!-- <div>{{ invoice?.address || '' }}</div> -->
                <div>{{ invoice?.fName || '' }} {{ invoice?.lName || '' }}</div>
                <div>{{ invoice?.street || '' }}</div>
                <div>{{ invoice?.city || '' }} {{invoice?.code || ''}}</div>
                <div>{{ invoice?.country || '' }}</div>
                <!-- <div>{{ invoice?.email || '' }}</div>
                <div>{{ invoice?.phone || '' }}</div> -->
              </div>
            </div>
          </div>

          <!-- Invoice Items Table -->
          <table class="invoice-table">
            <thead>
              <tr>
                <th style="width: 15%;">Item</th>
                <th style="width: 35%">Description</th>
                <th style="width: 15%;">Quantity</th>
                <th style="width: 17.5%;">Unit Cost</th>
                <th style="width: 17.5%;">Line Total</th>
              </tr>
            </thead>
            <tbody>
              @for (item of invoice?.lines || []; track item.id) {
                <tr>
                  <td>{{ item.name || '-' }}</td>
                  <td>{{ item.description || '-' }}</td>
                  <td>{{ item.qty || 0 | number:'1.2-2' }}</td>
                  <td>{{ item?.unitCost?.code || '' }} {{ item?.unitCost?.amount || 0 | number:'1.2-2' }}</td>
                  <!-- <td>{{ item?.amount?.code || '' }} {{ (item.qty * item?.unitCost?.amount) || 0 | number:'1.2-2' }}</td> -->
                  <td>{{ item?.amount?.code || '' }} {{ item?.amount?.amount || 0 | number:'1.2-2' }}</td>
                </tr>
              }
              @if(!invoice?.lines || invoice?.lines?.length === 0) {
                <tr>
                  <td>Service</td>
                  <td>Professional Services</td>
                  <td>1</td>
                  <td>{{ invoice?.amount?.code || '' }} {{ invoice?.amount?.amount || 0 | number:'1.2-2' }}</td>
                  <td>{{ invoice?.amount?.code || '' }} {{ invoice?.amount?.amount || 0 | number:'1.2-2' }}</td>
                </tr>
              }
            </tbody>
          </table>

          <!-- Invoice Summary -->
          <div class="invoice-summary">
            <div class="summary-row">
              <span>Sub Total</span>
              <span>{{ invoice?.amount?.code || '$' }}{{ getSubtotal() | number:'1.2-2' }}</span>
            </div>
            @for (tax of getUniqueTaxes(); track tax.taxName1 + '_' + tax.taxAmount1) {
              <div class="summary-row">
                <span>{{ tax.taxName1 }} ({{ tax.taxAmount1 }}%)</span>
                <span>{{ invoice?.amount?.code || '$' }} {{ (getSubtotal() * tax.taxAmount1 / 100) | number:'1.2-2' }}</span>
              </div>
            }
            <!-- <div class="summary-row">
              <span>GST({{ invoice?.gstPercent || 0 }}%)</span>
              <span>{{ invoice?.amount?.code || '$' }}{{ getGST() | number:'1.2-2' }}</span>
            </div> -->
            <div class="summary-row total">
              <span>Total</span>
              <span>{{ invoice?.amount?.code || '$' }}{{ getTotal() | number:'1.2-2' }}</span>
            </div>
            <div class="summary-row amount-paid">
              <span>Amount Paid</span>
              <span>- {{ invoice?.paid?.code || '$' }}{{ invoice?.paid?.amount || 0 | number:'1.2-2' }}</span>
            </div>
            <div class="summary-row amount-due">
              <span>Amount Due</span>
              <span>{{ invoice?.outstanding?.code || '$' }}{{ invoice?.outstanding?.amount || 0 | number:'1.2-2' }}</span>
            </div>
          </div>

          <!-- Payment Status -->
          <!-- <div style="text-align: center;">
            <span class="status-badge" [ngClass]="getStatusClass()">
              {{ invoice?.paymentStatus | titlecase }}
            </span>
          </div> -->

          <!-- Invoice Footer -->
          <!-- <div class="invoice-footer">
            <p>Thank you for your business!</p>
            <p style="margin-top: 10px;">For any queries, please contact us at info&#64;workluge.com</p>
          </div> -->

          <!-- Disclaimer Section -->
          <div class="invoice-disclaimer">
            @if(invoice?.terms) {
              <div class="disclaimer-section">
                <strong>Terms:</strong>
                <p>{{ invoice?.terms }}</p>
              </div>
            }
            @if(invoice?.notes) {
              <div class="disclaimer-section">
                <strong>Notes:</strong>
                <p>{{ invoice?.notes }}</p>
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="invoice-modal-footer">
        <div class="footer-left">
          <div style="display: flex; align-items: center; gap: 8px; font-size: 13px; color: var(--color-text-secondary); font-family: 'Outfit', sans-serif;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">info</mat-icon>
            <span>Click download to save this invoice</span>
          </div>
        </div>
        <div class="footer-right">
          <button class="btn-download" (click)="downloadInvoice()" [disabled]="isLoading()">
            @if(isLoading()) {
              <app-spinner [size]="20"></app-spinner>
            } @else {
              <mat-icon>download</mat-icon>
            }
            Download Invoice
          </button>
          <button class="btn-secondary" (click)="onClose()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>

